import { useMutation } from '@tanstack/react-query';

import { ComponentDeviceConfig } from 'src/features/systems/utils/deviceConfigFields';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/system/component/:componentId/device-config/`;

interface DTO {
    parkingId: string;
    componentId: string;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, componentId }: DTO): Promise<ComponentDeviceConfig> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId, componentId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateComponentDeviceConfig };
